export function getClassNameAsString(element: any): string {
  if (!element?.className) {
    return "";
  }

  if (typeof element.className === "string") {
    return element.className;
  }

  return element.className.baseVal || "";
}
